var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetalhe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1765",
    "data-name": "Ret\\xE2ngulo 1765",
    width: 27,
    height: 27,
    transform: "translate(0 -0.001)",
    fill: "#0078d9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2044",
    "data-name": "Grupo 2044",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2043",
    "data-name": "Grupo 2043",
    transform: "translate(0 -0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5532",
    "data-name": "Caminho 5532",
    d: "M240.888,140.2l-.882,4.3a.371.371,0,0,0,.433.433l4.3-.882.188-.1,9.241-9.241a.185.185,0,0,0,0-.262l-3.673-3.673a.185.185,0,0,0-.262,0l-9.241,9.241-.1.188",
    transform: "translate(-232.05 -126.39)",
    fill: "#0078d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5533",
    "data-name": "Caminho 5533",
    d: "M23.32,93.259H21.73a.53.53,0,0,0-.53.53v7.42H2.65V82.659h6.1a.53.53,0,0,0,.53-.53v-1.59a.53.53,0,0,0-.53-.53H1.325A1.325,1.325,0,0,0,0,81.334v21.2a1.325,1.325,0,0,0,1.325,1.325h21.2a1.325,1.325,0,0,0,1.325-1.325V93.789a.53.53,0,0,0-.53-.53",
    transform: "translate(0 -77.359)",
    fill: "#0078d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5534",
    "data-name": "Caminho 5534",
    d: "M618.139,2.9,615.515.272a.927.927,0,0,0-1.312,0l-1.937,1.937a.265.265,0,0,0,0,.375l3.56,3.56a.265.265,0,0,0,.375,0l1.937-1.937a.927.927,0,0,0,0-1.312",
    transform: "translate(-591.91 0)",
    fill: "#0078d9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetalhe);
export default __webpack_public_path__ + "static/media/detalhe.b73d297ec69174e4504f1b82b6165a14.svg";
export { ForwardRef as ReactComponent };